import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

import fileManagerIcon from '../icons/filemanager-icon.png';
import lifeCheckIcon from '../icons/lifecheck-icon.png';
import dazzleIcon from '../icons/dazzle-icon.png';

import fileManagerImg from '../images/Favorites-fileManager.jpg';
import lifeCheckImg from '../images/Favorites-lifeCheck.jpg';
import dazzleImg from '../images/Favorites-dazzle.jpg';

import '../styles/Favorites.css';

class Favorites extends React.Component {

  static contextTypes = {
    openModal: PropTypes.func
  };

  render() {
    return (
      <div className={classnames('Favorites', this.props.className)}>
        <div className="Favorites-content">
          <h2 className="Favorites-title">
            {`Other Favorite Projects`}
          </h2>
          <div className="Favorites-projects">
            {
              [
                {
                  title: 'File Manager',
                  subtitle: 'iOS',
                  description: `The next generation of the mobile\nfile manager for easy and efficient\nfile management`,
                  icon: fileManagerIcon,
                  size: { width: 254, height: 214 }
                },
                {
                  title: 'LifeCheck',
                  subtitle: 'Web+Android',
                  description: `Awarded 4th place in 2012 GSMA\nHealth Confernece in South Africa\nand the best startup in UC Berkeley`,
                  icon: lifeCheckIcon,
                  size: { width: 172, height: 154 }
                },
                {
                  title: 'Dazzle',
                  subtitle: 'Research',
                  description: `A shared display system \nfor product design teams:\nHCI research project in UC Berkeley`,
                  icon: dazzleIcon,
                  size: { width: 198, height: 168 }
                }
              ].map(({ title, subtitle, description, icon, size }, idx) => (
                <div
                  key={idx}
                  className="Favorites-projectLink"
                  onClick={this._onClickProject.bind(this, idx)}>
                  <div className="Favorites-projectIconWrapper">
                    <div
                      className="Favorites-projectIcon"
                      style={{
                        width: `${size.width / 2}px`,
                        height: `${size.height / 2}px`,
                        backgroundImage: `url(${icon})`,
                        backgroundSize: `${size.width / 2}px ${size.height / 2}px`
                      }}
                    />
                  </div>
                  <h3 className="Favorites-projectTitle">
                    {title}
                  </h3>
                  <p className="Favorites-projectSubtitle">
                    {subtitle}
                  </p>
                  <p className="Favorites-projectDescription">
                    {description}
                  </p>
                </div>
              ))
            }
          </div>
        </div>
      </div>
    );
  }

  _onClickProject = (idx) => {
    let modal;

    switch (idx) {
      case 0:
        modal = (
          <div className="Favorites-fileManagerModal">
            <div
              className="Favorites-fileManagerBg"
              style={{
                backgroundImage: `url(${fileManagerImg})`
              }}
            />
            <div className="Favorites-fileManagerDescription">
              {'File Manager (code name) is an iPhone productivity app for easy and efficient file management between your iPhone and web storage services. The app is in development.'}
            </div>
          </div>
        );
        break;
      case 1:
        modal = (
          <div
            className="Favorites-lifeCheckModal"
            style={{
              backgroundImage: 'url(' + lifeCheckImg + ')'
            }}>
            <div className="Favorites-lifeCheckContent">
              <h3 className="Favorites-lifeCheckTitle">
                {'LifeCheck'}
              </h3>
              <div className="Favorites-lifeCheckDescription">
                {`In a team of two business (Hung and VIvian) and four technical students (Jesse, Mark, Jonathan, and Kyu), we created a medical checklist platform in the mobile venture lab in UC Berkeley. We were chosen as the best startup team by VCs in UC Berkeley Mobile Competition in 2011 and awarded 4th place in the 2012 GSMA Mobile Health University Challenge in Cape Town, South Africa (1st MIT, 2nd Univ. of Oxford, 3rd, Jordan University).`}
              </div>
              <div className="Favorites-lifeCheckVideoWrapper">
                <iframe
                  title="LifeCheck"
                  className="Favorites-lifeCheckVideo"
                  width="434"
                  height="244"
                  src="//www.youtube.com/embed/Ukx_G2CSq7o?rel=0&amp;showinfo=0"
                  frameBorder="0"
                  allowFullScreen
                />
              </div>
            </div>
          </div>
        );
        break;
      case 2:
        modal = (
          <div className="Favorites-dazzleModal">
            <div className="Favorites-dazzleDescription">
              <h3 className="Favorites-dazzleTitle">
                {`Dazzle`}
              </h3>
              <p>{`Dazzle is a shared display system for product design teams. As an undergraduate researcher in Berkeley Institue of Design, I designed and implemented Dazzle with Professor Hartmann and Lora Oehlberg (PhD Candidate 2012).`}</p>
              <p>{`Dazzle supports comments and tagging as well as screen sharing using Adobe Connect and file sharing via Dropbox. The backend component is built in using Adobe LiveCycle Collaboration with push technology. This allows Dazzle to automatically update the comment and tag list as other users add them.`}</p>
              <a
                className="Favorites-dazzleLink"
                href="http://dl.acm.org/citation.cfm?doid=2317956.2318057"
                target="_blank"
                rel="noopener noreferrer">
                <p><b>Publication</b>: Lora Oehlberg, <b>Kyu Simm</b>, Jasmine Jones, Alice M. Agogino, Bjoern Hartmann. "Showing is sharing: building shared understanding in human-centered design teams with Dazzle". In Proceedings of Designing Interactive Systems Conference 2012.<br/>(Click here to see the article)</p>
              </a>
            </div>
            <div
              className="Favorites-dazzleImage"
              style={{
                backgroundImage: `url(${dazzleImg})`
              }}
            />
          </div>
        );
        break;
      default:
        break;
    }

    this.context.openModal(modal);
  };

}

export default Favorites;



// WEBPACK FOOTER //
// ./src/components/Favorites.js